export default __webpack_public_path__ + "static/media/money-mouth.b25e4ce0.png";